import { createSelector } from '@reduxjs/toolkit';
import selectRawWorkflows from './selectRawWorkflows';
import selectRawIntegrations from './selectRawIntegrations';

export default createSelector(selectRawWorkflows, selectRawIntegrations, (workflows, integrations) => [
  ...integrations,
  ...workflows,
]);
